import Navigation from '@/components/navigation/Navigation'
import Dashboard from '@/components/Dashboard'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'dashboard',
				name: 'Dashboard',
				meta: {
					requiredAuth: true
				},
				components: {
					default: Dashboard,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/dashboard.js